import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Platform } from '../../models/platform';

@Pipe({ name: 'platform' })
export class PlatformPipe implements PipeTransform {
  private translateService = inject(TranslateService);


  transform(value: string): string {
    switch (value) {
      case Platform.ANDROID:
        return this.translateService.instant('configurations.platforms.android');
      case Platform.WINDOWS:
        return this.translateService.instant('configurations.platforms.windows');
    }
    return value;
  }
}
